<div class="versions-container">
  <div class="category-label">Versions</div>
  <div class="content">
    @for (version of versions; track $index; let last = $last) {
    <div class="header" (click)="onVersionDetailClick(version)">
      <div class="header-group">
        <div class="header-label">{{ version.version }}</div>
        @if (version.beta) {
        <app-status-badge [status]="betaStatus" />
        }
      </div>
      <div class="header-group">
        @if (version.isNew) {
        <app-status-badge [status]="newStatus" />
        }
        <i
          class="pi pi-chevron-down"
          style="color: var(--text-color-secondary)"
          [@rotate]="version.isShown ? 'rotated' : 'default'"
        ></i>
      </div>
    </div>
    <div class="body" [@verticalSlideToggle]="version.isShown ? 'open' : 'closed'">
      <div class="h-divider"></div>
      <div class="label-value">
        <div class="label">Release Date</div>
        <div class="value">{{ version.date }}</div>
      </div>
      <div>
        <div class="description-label">Description</div>
        <ul class="list">
          <li class="list-text">
            {{ version.description }}
          </li>
        </ul>
      </div>
      @if (version.features) {
      <div [ngClass]="{ padded: !version.bugFixes }">
        <div class="description-label">Features</div>
        <ul class="list">
          @for (feature of version.features; track $index) {
          <li class="list-text">
            {{ feature }}
          </li>
          }
        </ul>
      </div>
      } @if (version.bugFixes) {
      <div class="padded">
        <div class="description-label">Bug Fixes</div>
        <ul class="list">
          @for (bugFix of version.bugFixes; track $index) {
          <li class="list-text">
            {{ bugFix }}
          </li>
          }
        </ul>
      </div>
      }
    </div>
    @if (!last) {
    <div class="h-divider"></div>
    } }
  </div>
</div>
